import React from 'react';

export default {
    TradChn : {
        formTitle: "遞交文書清單", 

        // Form fields
        part_a_particulars: "遞交文書清單", 

        // Form - Part1
        SolicitorCode: "律師代號",
        NameOfLodgingParty: "交契人士姓名",
        Date: "日期",
        HaveCheque: "使用支票繳交費用",
        field_HaveCheque_list:[
            {id: "HaveCheque", value: "Yes", text: "是"},
            {id: "HaveCheque", value: "No", text: "否", },
        ],
        NoOfCheques: "支票數目",
        TotalAmount: "總額",

        RecordListTitle: "文書清單",
        OrderOfLodgement: "遞交文書次序",
        NatureOfInstrument: "文書性質",
        PRN: "受影響處所的物業參考編號/地址(包括座號、層數及單位)/地段編號(包括座號、層數及單位) ",

        Warn_IdenticalInstrument: ()=><>下列文書的描述完全相同。<br/>請檢查後再進行下一步。</>,
        Warn_OrderOfLodgement: "文書次序 #{0} 和 #{1}",

        notes1: ()=> [<>
            <div>
                如以郵遞方式寄交本表格，請確保為郵件支付足夠郵資，以免申請未能成功送達本處。郵資不足的郵件會由香港郵政處理，本處不會代為繳付欠款及附加費。
            </div>
        </>],


        acknowledgement_offline_para: ()=>(
            <>
                    <p>你的表格已成功列印。</p>
                    <p>請親身遞交，或以郵寄/傳遞公司傳送表格至本處以遞交申請。</p>
            </>
        ),
    }
}